//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { tableOption, dicOption } from '@/views/visual/dataScreen/js/option/config';
import codeedit from '@/views/visual/dataScreen/group/code';
export default {
  data: function data() {
    return {
      dicOption: dicOption,
      tableOption: tableOption,
      code: {
        box: false,
        type: 'data',
        obj: {}
      }
    };
  },
  inject: ["main"],
  components: {
    codeedit: codeedit
  },
  methods: {
    rowSave: function rowSave(row, done) {
      this.main.activeOption.column.push(this.deepClone(row));
      done();
    },
    rowDel: function rowDel(row, index) {
      this.main.activeOption.column.splice(index, 1);
    },
    rowUpdate: function rowUpdate(row, index, done) {
      this.main.activeOption.column.splice(index, 1, this.deepClone(row));
      done();
    },
    codeClose: function codeClose(value) {
      this.main.activeOption.column = value;
    },
    openCode: function openCode() {
      this.code.obj = this.main.activeOption.column;
      this.code.box = true;
    }
  }
};